import { Component, Element, Prop, Watch } from '@stencil/core';

import { clearThemeStyles, setThemeStyles } from './uui-theme';

/**
 * @slot default - Slot for the style object
 */
@Component({
  tag: 'uui-theme-provider'
})
export class UUIThemeProvider {
  @Prop() name: string;
  @Prop() version: string;
  @Prop() global = true;
  @Element() el: HTMLElement;

  @Watch('name')
  validateName(newValue: string, _oldValue: string) {
    const isBlank = typeof newValue !== 'string' || newValue === '';
    if (isBlank) {
      throw new Error('name: required');
    }
  }

  connectedCallback() {
    const styles: NodeListOf<HTMLStyleElement> = this.el.querySelectorAll(
      'style'
    );
    if (styles?.length) {
      const { name, version, global } = this;
      const themeStyles = Array.from(styles);
      setThemeStyles({ name, version, themeStyles, global });
    }
  }

  disconnectedCallback() {
    clearThemeStyles(this.name);
  }
}
